import { InjectionToken } from '@angular/core';
import { SubmissionTypesAdminState } from '../types/submission-types-admin.types';
import { GridType } from '@data-access/grid-views';
import { DEFAULT_BASE_GRID_PROPS } from '@data-access/shared';
import environment from '@environments/environment';


export const ADMIN_SUBMISSIONS_URL = `${environment.irisApi}/v2/admin/workspace`;
export const ADMIN_WORKSPACE_TYPE_URL = `${environment.irisApi}/admin/workspace/type`;

/**
 * Initial state for submission admin
 */
export const SUBMISSION_TYPES_INITIAL_STATE: SubmissionTypesAdminState = {
  data: [],
  views: [],
  gridType: 'workspace-type-v2' as GridType,
  selectedWorkspaceSubType: null,
  irisRoutingGroupData: {
    data: [],
    total: 0,
  },
  ...DEFAULT_BASE_GRID_PROPS,
};

/**
 * Injection token for submission admin initial state
 */
export const SUBMISSION_TYPES_INITIAL_STATE_TOKEN =
  new InjectionToken<SubmissionTypesAdminState>(
    'submission type admin grid state',
    {
      factory: () => ({ ...SUBMISSION_TYPES_INITIAL_STATE }),
    },
  );
